import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function DryRunRibbon() {
    const { settings } = useSiteSettings();
    if (!settings?.launch_dry_run_mode) return null;
    const routing = settings?.notification_routing || {};
    const primary = routing.primary_recipient || settings?.email;
    return (
        <div
            className="text-center text-[11px] sm:text-xs font-bold uppercase tracking-widest py-1.5"
            style={{
                background: "var(--color-warning)",
                color: "var(--color-cta-ink)",
            }}
            data-testid="dry-run-ribbon"
            title={routing.dry_run_shadow_recipient ? `Dry-run capture inbox: ${routing.dry_run_shadow_recipient}` : undefined}
        >
            DRY RUN MODE — no live customer notifications · primary alert recipient {primary}
        </div>
    );
}
